import classNames from "classnames"
import { IFormDataInput } from "../../model/IFormDataInput"
import { getDatePickerPattern, getSpecialCharacterPattern } from "../../utils/patternHelper"
import { IChildPlanFormData } from "../ChildPlanFormDataContext"
import { ResponsiveWidth } from "./ParentDataObject"

export const ChildFormDataInputObject: IFormDataInput[] = [{
    Id: 'ChildFnInput',
    Name: 'FirstName',
    Type: 'text',
    ControlType: 'InputBox',
    Placeholder: 'First Name.',
    Label: 'firstName',
    Required: true,
    ClassName: 'pt-2 lg:ml-2',
    Width: classNames(ResponsiveWidth, "border-[1.5px] border-gray-400"),
    Height: 'h-10',
    Shadow: 'shadow-md',
    ErrorMessageList: [
        { type: 'required', error: 'required' },
        { type: 'pattern', error: 'specialcharpatternerror' },
    ],
    ErrorMessage: '',
    Pattern: getSpecialCharacterPattern(),
    IsValid: false,
    IsBlur: false,
    IsFocus: false,
    Disabled: false,
},
{
    Id: 'ChildLnInput',
    Name: 'LastName',
    Type: 'text',
    ControlType: 'InputBox',
    Placeholder: 'Last Name.',
    Label: 'lastName',
    Required: true,
    ClassName: 'pt-2',
    Width: classNames(ResponsiveWidth, "border-[1.5px] border-gray-400"),
    Height: 'h-10',
    Shadow: 'shadow-md',
    ErrorMessageList: [
        { type: 'required', error: 'required' },
        { type: 'pattern', error: 'specialcharpatternerror' },
    ],
    ErrorMessage: '',
    Pattern: getSpecialCharacterPattern(),
    IsValid: false,
    IsBlur: false,
    IsFocus: false,
    Disabled: false,
},
{
    Id: 'ChildDobPicker',
    Name: 'Dob',
    Type: '',
    ControlType: 'DatePicker',
    Placeholder: 'dateformat',
    Label: 'dob',
    Required: true,
    ClassName: 'pt-1',
    Width: classNames(ResponsiveWidth, "border-[1.5px] border-gray-400"),
    Height: 'h-10',
    Shadow: 'shadow-md',
    ErrorMessageList: [{ type: 'required', error: 'required' }],
    ErrorMessage: '',
    Pattern: getDatePickerPattern(),
    IsValid: false,
    IsBlur: false,
    IsFocus: false,
    Disabled: false,
},
{
    Id: 'SchoolDDL',
    Name: 'School',
    Type: '',
    ControlType: 'DropDownList',
    ListItems: [{ id: '', name: '' }],
    Placeholder: '',
    Label: 'school',
    Required: true,
    ClassName: 'z-0 lg:mb-11 lg:pt-1 ',
    Width: classNames(ResponsiveWidth),
    Height: 'h-10',
    Shadow: '',
    ErrorMessageList: [{ type: 'required', error: 'required' }],
    ErrorMessage: '',
    Pattern: '',
    IsValid: false,
    IsBlur: false,
    IsFocus: false,
    Disabled: false,
}]

export const ChildDataObject: IChildPlanFormData = {
    FirstName: '',
    LastName: '',
    Dob: '',
    School: { id: '', name: '' },
    Plan: {
        PlanCode: '',
        Primary: '',
        Premium: 0,
        Index: -1,
        IsValid: false,
    },
    ChildPlanFormDataInput: ChildFormDataInputObject,
    SetValidationFocus: false
}

